/** Created by azhou on 2018/7/6.*/
<template>
  <div class="position-absolute w-100">
    <!--标题部分-->
    <public-title>数据统计
      <span class="text-link ml-auto mr-5" slot="right" @click="showEchart=true">图表模式查看</span>
    </public-title>
    <div class="bg-white p-5 mr-5">
      <div class="text-right p-2 mb-5">
        <el-date-picker class="w-30" size="small" v-model="timestamp" type="daterange" value-format="timestamp" start-placeholder="开始时间" end-placeholder="结束时间" />
        <!-- <el-button class="ml-2" type="primary" size="small" @click="getStatsData">搜索</el-button> -->
      </div>
      <!--报表2.0版本-->
      <el-table :data="tableData" border :row-class-name="tableRowClassName">
        <el-table-column fixed="left" prop="roleName" label="用户身份" width="80" />
        <el-table-column :prop="columnItem.prop" :label="columnItem.label" v-for="columnItem in tabColumn" :key="columnItem.roleType" :width="columnItem.w" />
      </el-table>
    </div>
    <!--echart图表全屏显示-->
    <transition name="fade">
      <echart-stat v-if="showEchart" @closeEchart="showEchart = false" />
    </transition>
  </div>
</template>

<script>
  import EchartStat from './EchartStat/EchartStat'
  import {mapState,mapActions} from 'vuex'

  export default {
    data() {
      return {
        showEchart:true,
        timestamp:'',
        tableData: [],
        tabColumn: [
          {prop: 'reg_nums', label: '认证数',w:80},
          {prop: 'verify_nums', label: '认证数',w:80},
          {prop: 'contract_nums', label: '签约数',w:80},
          {prop: 'active_nums',label: '活跃数',w:80},
          {prop: 'send_order_store_nums', label: '发单采购商数',w:120},
          {prop: 'active_user_nums', label: '发单人数',w:100},
          {prop: 'send_order_nos', label: '发单总数',w:110},
          {prop: 'offer_store_nums',label: '报价酒店数',w:110},
          {prop: 'offer_nums',label: '报价总次数',w:110},
          {prop: 'success_order_nos', label: '成交订单数',w:100},
          {prop: 'on_line_pay_nums', label: '在线支付订单数',w:120},
          {prop: 'send_unit_price',label: '发布订单客单价',w:120},
          {prop: 'unit_price',label: '成交订单客单价',w:120},
          {prop: 'send_order_offer_money', label: '发布订单总额',w:120},
          {prop: 'success_order_money', label: '成交订单总额',w:120},
          {prop: 'on_line_pay_money', label: '在线支付订单总额',w:140},
          {prop: 'offline_pay', label: '线下支付订单总额',w:140},
          {prop: 'red_packet_pay_money', label: '红包抵扣',w:140},
          {prop: 'rebate_money',label: '采购商返点总额',w:120},
          {prop: 'commision_money', label: '佣金总额',w:120},
          {prop: 'withdraw_money', label: '申请提现',w:120},
          {prop: 'success_withdraw_money', label: '提现实际打款',w:120},
          {prop: 'ffpay_money',label: '第三方平台实付总金额',w:120},
          {prop: 'ffpay_money_end', label: '第三方平台实收总手续费',w:120}
        ]
      }
    },
    computed: {
      ...mapState(['AdminDataLists']),
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
    },
    watch:{
      AdminDataLists(newVal) { this.formatStatsData(newVal.lists) }
    },
    components: { EchartStat },
    mounted() {
      // this.getStatsData();
      $('.view-wrap').css('width',$('html,body').width() * 0.73  + 'px');
    },
    methods: {
      ...mapActions(['getAdminDataLists']),
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 4) {
          return 'success-row';
        }
        return '';
      },
      /*整理报表数据*/
      formatStatsData(data) {
        let tableItem = {
          roleType: '',
          roleName: ''
        };
        this.tableData = [];    //每次清空上一次push进去的数据
        for (let key in data) {
          tableItem.roleType = key;
          switch (key) {
            case '2':tableItem.roleName = '采购商'; break;
            case '3':tableItem.roleName = '酒店'; break;
            case '4':tableItem.roleName = '导游'; break;
            case '5':tableItem.roleName = '民宿'; break;
            case '6':tableItem.roleName = '景区'; break;
            case 'sum':tableItem.roleName = '总计'; break;
          }
          this.tableData.push({...tableItem, ...data[key]});
        }
        this.tableData.forEach(item => {
          if (item.rebate_money > 0) item.rebate_money = this.$options.filters['formatMoney'](item.rebate_money / 100);
          if (item.commision_money > 0) item.commision_money = this.$options.filters['formatMoney'](item.commision_money / 100);
          if (item.on_line_pay_money > 0) item.on_line_pay_money = this.$options.filters['formatMoney'](item.on_line_pay_money / 100);
          if (item.offline_pay > 0) item.offline_pay = this.$options.filters['formatMoney'](item.offline_pay / 100);
          if (item.red_packet_pay_money > 0) item.red_packet_pay_money = this.$options.filters['formatMoney'](item.red_packet_pay_money / 100);
          if (item.withdraw_money > 0) item.withdraw_money = this.$options.filters['formatMoney'](item.withdraw_money / 100);
          if (item.success_withdraw_money > 0) item.success_withdraw_money = this.$options.filters['formatMoney'](item.success_withdraw_money / 100);
          if (item.ffpay_money > 0) item.ffpay_money = this.$options.filters['formatMoney'](item.ffpay_money / 100);
          if (item.ffpay_money_end > 0) item.ffpay_money_end = this.$options.filters['formatMoney'](item.ffpay_money_end / 100);
          if (item.send_unit_price > 0) item.send_unit_price = this.$options.filters['formatMoney'](item.send_unit_price);
          if (item.unit_price > 0) item.unit_price = this.$options.filters['formatMoney'](item.unit_price);
          if (item.send_order_offer_money > 0) item.send_order_offer_money = this.$options.filters['formatMoney'](item.send_order_offer_money);
          if (item.success_order_money > 0) item.success_order_money = this.$options.filters['formatMoney'](item.success_order_money);
        });
      },
      // /*获取报表数据*/
      // getStatsData() {
      //   this.getAdminDataLists({
      //     type:'chart',
      //     data:{
      //       start_time: this.startTime,
      //       end_time: this.endTime
      //     }
      //   });
      // },
    }
  }
</script>
